import { render, staticRenderFns } from "./ItemExtra.vue?vue&type=template&id=0bf7313e"
import script from "./ItemExtra.vue?vue&type=script&lang=js"
export * from "./ItemExtra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports